import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography} from '@mui/material';
import {Person as PersonIcon} from '@mui/icons-material';
import MemberBadgeSection from './MemberBadgeSection';

const MemberForm = ({
                        open,
                        editingMember,
                        formData,
                        units,
                        user,
                        onClose,
                        onSubmit,
                        onFormDataChange,
                        viewMode = false,
                    }) => {
    const handleChange = (field, value) => {
        onFormDataChange({...formData, [field]: value});
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={onSubmit}>
                <DialogTitle sx={{
                    bgcolor: viewMode ? 'info.main' : 'primary.main',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}>
                    <PersonIcon/>
                    {viewMode ? 'Mitglied ansehen' : (editingMember ? 'Mitglied bearbeiten' : 'Neues Mitglied erstellen')}
                </DialogTitle>
                <DialogContent sx={{pt: 3}}>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
                        {/* Persönliche Daten */}
                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                            <Typography variant="subtitle2" color="primary" gutterBottom sx={{fontWeight: 600}}>
                                Persönliche Daten
                            </Typography>
                            <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                                <TextField
                                    select
                                    label="Geschlecht"
                                    value={formData.gender}
                                    onChange={(e) => handleChange('gender', e.target.value)}
                                    fullWidth
                                    disabled={viewMode}
                                    slotProps={{inputLabel: {shrink: true}}}
                                >
                                    <MenuItem value="">Nicht angegeben</MenuItem>
                                    <MenuItem value="MALE">Männlich</MenuItem>
                                    <MenuItem value="FEMALE">Weiblich</MenuItem>
                                    <MenuItem value="DIVERS">Divers</MenuItem>
                                    <MenuItem value="UNKNOWN">Unbekannt</MenuItem>
                                </TextField>
                            </Box>
                            <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                                <TextField
                                    label="Vorname"
                                    value={formData.firstName}
                                    onChange={(e) => handleChange('firstName', e.target.value)}
                                    required
                                    fullWidth
                                    disabled={viewMode}
                                />
                                <TextField
                                    label="Nachname"
                                    value={formData.lastName}
                                    onChange={(e) => handleChange('lastName', e.target.value)}
                                    required
                                    fullWidth
                                    disabled={viewMode}
                                />
                            </Box>
                            <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                                <TextField
                                    label="Geburtsdatum"
                                    type="date"
                                    value={formData.dateOfBirth}
                                    onChange={(e) => handleChange('dateOfBirth', e.target.value)}
                                    required
                                    fullWidth
                                    disabled={viewMode}
                                    slotProps={{inputLabel: {shrink: true}}}
                                />
                                <TextField
                                    label="aktuelles Alter"
                                    value={formData.dateOfBirth ? `${Math.floor((new Date() - new Date(formData.dateOfBirth)) / (1000 * 60 * 60 * 24 * 365.25))} Jahre` : ''}
                                    fullWidth
                                    disabled
                                />
                            </Box>
                        </Box>

                        {/* Mitgliedschaft */}
                        <Box>
                            <Typography variant="subtitle2" color="primary" gutterBottom sx={{fontWeight: 600}}>
                                Mitgliedschaft
                            </Typography>
                            <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                                <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                                    {editingMember && (
                                        <TextField
                                            select
                                            label="Einheit"
                                            value={formData.unitId}
                                            onChange={(e) => handleChange('unitId', e.target.value)}
                                            required
                                            fullWidth
                                            disabled={viewMode}
                                        >
                                            <MenuItem value="">Bitte wählen</MenuItem>
                                            {units.map((unit) => (
                                                <MenuItem key={unit.id} value={unit.id}>
                                                    {unit.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                    <TextField
                                        label="Mitglieds-Nr."
                                        value={formData.memberCardId}
                                        onChange={(e) => handleChange('memberCardId', e.target.value)}
                                        fullWidth
                                        placeholder="Optional"
                                        disabled={viewMode}
                                    />
                                </Box>
                                <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                                    <TextField
                                        label="Aktiv seit"
                                        type="date"
                                        value={formData.activeSince}
                                        onChange={(e) => handleChange('activeSince', e.target.value)}
                                        required
                                        fullWidth
                                        disabled={viewMode}
                                        slotProps={{inputLabel: {shrink: true}}}
                                    />
                                    <TextField
                                        label="Aktiv bis"
                                        type="date"
                                        value={formData.activeUntil || ''}
                                        onChange={(e) => handleChange('activeUntil', e.target.value)}
                                        fullWidth
                                        disabled={viewMode}
                                        slotProps={{inputLabel: {shrink: true}}}
                                    />
                                </Box>

                            </Box>
                            {!editingMember && (
                                <Typography variant="caption" color="textSecondary" sx={{mt: 1, display: 'block'}}>
                                    Das Mitglied wird automatisch Ihrer Einheit ({user?.unit?.name || 'Einheit'}) zugeordnet.
                                </Typography>
                            )}
                        </Box>


                        {/* Abzeichen - nur bei bestehendem Mitglied */}
                        {editingMember && (
                            <MemberBadgeSection
                                memberId={editingMember.id}
                                initialBadges={editingMember.badges}
                                viewMode={viewMode}
                            />
                        )}
                    </Box>
                </DialogContent>
                <DialogActions sx={{px: 3, py: 2, bgcolor: 'grey.50'}}>
                    <Button onClick={onClose} color="inherit">
                        {viewMode ? 'Schließen' : 'Abbrechen'}
                    </Button>
                    {!viewMode && (
                        <Button type="submit" variant="contained" size="large">
                            {editingMember ? 'Aktualisieren' : 'Mitglied erstellen'}
                        </Button>
                    )}
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default MemberForm;

